$('body').on('click','#calculateFromModalPdp', function (e) {
    e.preventDefault();
    var inputSeno = $('#myRangeSeno').val();
    var inputSottoSeno = $('#myRangeSottoSeno').val();

    if( inputSeno!=undefined && inputSottoSeno!=undefined && inputSeno!="" && inputSottoSeno!=""){
        var bikiniTopTableString = $('#findYourSizeBikiniTop').val();
        var bikiniTopTable = JSON.parse(bikiniTopTableString);
        var inputSenoSize = parseInt(inputSeno);
        var inputSottoSenoSize = parseInt(inputSottoSeno);
        calculateBraSizeFromPdp(inputSenoSize, inputSottoSenoSize, bikiniTopTable);
    }else{
     if(inputSeno == undefined || inputSeno == ""){
        $('#inputSeno').addClass('inputInvalid');
        $('#errorSeno').removeClass('hidden');
     }
     if(inputSottoSeno == undefined || inputSottoSeno == ""){
        $('#inputSottoSeno').addClass('inputInvalid');
        $('#errorSottoSeno').removeClass('hidden');
     }
    }
});

$('body').on('focus','#inputSeno', function (e) {
    e.preventDefault();
    $('#inputSeno').removeClass('inputInvalid');
    $('#errorSeno').addClass('hidden');
});

$('body').on('focus','#inputSottoSeno', function (e) {
    e.preventDefault();
    $('#inputSottoSeno').removeClass('inputInvalid');
    $('#errorSottoSeno').addClass('hidden');
});

function calculateBraSizeFromPdp(inputSenoSize,inputSottoSenoSize,bikiniTopTable){

    var country = $('#findYourSizeBikiniTop').data('currentcountry');

    var size;

    var sizeArray = [];

    switch(country){
        case "it":
            bikiniTopTable = bikiniTopTable.it;
                break;
        case "es":
            bikiniTopTable = bikiniTopTable.es;
                break;
        case "fr":
            bikiniTopTable = bikiniTopTable.fr;
                break;
        case "us":
            bikiniTopTable = bikiniTopTable.us;
                break;
        case "uk":
            bikiniTopTable = bikiniTopTable.uk;
                break;
        default:
            bikiniTopTable = bikiniTopTable.eu;
                break;
    }

    for (var key in bikiniTopTable) {
        if('to' in bikiniTopTable[key].sottoSeno){
            if (inputSenoSize >= bikiniTopTable[key].seno.from && inputSenoSize <= bikiniTopTable[key].seno.to &&
                inputSottoSenoSize >= bikiniTopTable[key].sottoSeno.from && inputSottoSenoSize <= bikiniTopTable[key].sottoSeno.to) {
                size = key;
                sizeArray.push(size);
            }
        }else{
            if (inputSenoSize >= bikiniTopTable[key].seno.from && inputSenoSize <= bikiniTopTable[key].seno.to &&
                inputSottoSenoSize >= bikiniTopTable[key].sottoSeno.from) {
                size = key;
            }
        }
    }
    var newBikiniTopTable = [];
    for (var key in bikiniTopTable) {
        var obj={};
        obj.size = key;
        newBikiniTopTable.push(obj);
    }

    if(sizeArray[0] != undefined){
        $('.firstSuggestedSize').html(sizeArray[0]);
        var suggestedSizes;
        if (sizeArray[1] != undefined && sizeArray[0].trim() != sizeArray[1].trim()) {
            $('.your-size-result').removeClass('hidden')
            suggestedSizes = sizeArray[1]
            $('.secondSuggestedSize').html(suggestedSizes);
            $('.labelSecondSize').removeClass('hidden');
        }
        $('.wrongSize').addClass('hidden');
        $('.your-size-result').removeClass('hidden');
        $('body').trigger('product:calculateSize');
    }else{
        $('.your-size-result').addClass('hidden');
        $('.wrongSize').removeClass('hidden');
    }
}